import { render, staticRenderFns } from "./viewGoods.vue?vue&type=template&id=07e7fdc0&scoped=true&"
import script from "./viewGoods.vue?vue&type=script&lang=js&"
export * from "./viewGoods.vue?vue&type=script&lang=js&"
import style0 from "./viewGoods.vue?vue&type=style&index=0&id=07e7fdc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e7fdc0",
  null
  
)

export default component.exports